import { useNavigate } from "react-router-dom";
import { blogSummaries } from "@/blog/blogIndex";
import { trackBlogPostOpen } from "@/lib/analytics";

export default function BlogSection() {
  const navigate = useNavigate();

  const openPost = (post: (typeof blogSummaries)[number]) => {
    void trackBlogPostOpen(post.id, post.title);
    navigate(`/blog/${post.id}`);
  };

  return (
    <section id="blog" className="py-20 md:py-28 lg:py-32 bg-stem-cream">
      <div className="section-padding max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-12 md:mb-16">
          <div>
            <span className="label text-revelBlue mb-3 block">
              Stories & Ideas
            </span>
            <h2 className="heading-lg text-stem-dark">From My Notebook</h2>
          </div>
          <button
            onClick={() => navigate("/blog")}
            className="btn-dark text-sm py-2.5 px-5 hidden md:inline-flex whitespace-nowrap"
          >
            View All Stories
            <i className="ri-arrow-right-line" />
          </button>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {blogSummaries.map((post) => (
            <article
              key={post.id}
              onClick={() => openPost(post)}
              className="group bg-white rounded-2xl overflow-hidden border border-stem-sand hover:border-revelBlue/30 transition-all duration-300 cursor-pointer"
              role="link"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter") openPost(post);
              }}
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-3 mb-3">
                  <span className="px-3 py-1 bg-revelBlue/10 text-revelBlue text-xs font-semibold rounded-full uppercase tracking-wide">
                    {post.category}
                  </span>
                  <span className="text-xs text-stem-gray">
                    {post.readTime}
                  </span>
                </div>
                <h3 className="text-lg md:text-xl font-bold text-stem-dark mb-2 leading-snug group-hover:text-revelBlue transition-colors">
                  {post.title}
                </h3>
                <p className="text-sm text-stem-gray leading-relaxed line-clamp-2 mb-4">
                  {post.excerpt}
                </p>
                <span className="text-xs text-stem-lightgray font-medium">
                  {post.date}
                </span>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 md:hidden">
          <button
            onClick={() => navigate("/blog")}
            className="btn-dark w-full justify-center text-sm py-2.5 whitespace-nowrap"
          >
            View All Stories
            <i className="ri-arrow-right-line" />
          </button>
        </div>
      </div>
    </section>
  );
}
